import { render, staticRenderFns } from "./ManageShipments.vue?vue&type=template&id=77d6b6d4&scoped=true&"
import script from "./ManageShipments.vue?vue&type=script&lang=js&"
export * from "./ManageShipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d6b6d4",
  null
  
)

export default component.exports